module.exports = __webpack_public_path__ + "img/wrainb.403aa2a0.png";